<template>
  <div>
    <Tree
      ref="dTree"
      class="depart-tree"
      :props="props"
      :data="departs"
      node-key="id"
      :filter-node-method="filterNode"
      auto-expand-parent
      accordion
      highlight-current
      show-checkbox
      @check="handleCheckChange"
    >
      <div
        @click="departNodeClicked(node.key)"
        slot-scope="{ node }"
        class="d-flex align-items-center wd-100p"
      >
        <div class="tx-color-02">
          {{ node.label }}
        </div>
        <div class="btn-group mg-l-auto">
          <!-- <button @click.stop="addGroup(node.key)" type="button" class="btn btn-outline-light btn-xs btn-icon">
            <feather type="plus" class=""></feather>
          </button>
          <button @click.stop="removeGroup(node.key)" type="button" class="btn btn-outline-light btn-xs btn-icon">
            <feather type="minus" class=""></feather>
          </button> -->
        </div>
      </div>
    </Tree>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { Tree } from "element-ui";
import { request } from "@/api/all";
import { mapActions } from "vuex";
var LTT = require("list-to-tree");

export default {
  components: {
    Tree
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => null
    }
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      selcdDeps: [],
      props: {
        children: "children",
        label: "label",
        iid: "id"
      },
      count: 1,
      departsFlat: [],
      departs: []
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.departsFlat = res.data.departs;
          var ltt = new LTT(res.data.departs, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.departs = ltt.GetTree();
        }
      });
    },
    loadNode(node, resolve) {
      //if (node.level === 0) {
      //}
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    handleCheckChange(data) {
      this.$emit("on-depart-selected", {
        departs: this.$refs.dTree.getCheckedNodes().map(e => {
          return e.id;
        })
      });
    }
  }
};
</script>

<style></style>
